export default __webpack_public_path__ + "static/2021-769d9ec7beaefd80ddf6b97d0ec48ae5.jpg";